import React from "react";

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  className?: string;
}

const Input: React.FC<InputProps> = ({ className = "", onClick, ...props }) => {
  const handleClick = (e: React.MouseEvent<HTMLInputElement>) => {
    if (props.type === "date") {
      (e.target as HTMLInputElement).showPicker?.();
    }
    onClick?.(e);
  };

  return (
    <input
      className={`h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-500 focus:outline-none focus:ring focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800 ${className}`}
      onClick={handleClick}
      {...props}
    />
  );
};

export default Input;
